import axios from 'axios';
import {
  PAYMENT_SESSION_FAIL,
  PAYMENT_SESSION_LOADING,
  PAYMENT_SESSION_SUCCESS,
  PAYMENT_UPSELL_HIDE,
  PAYMENT_UPSELL_SHOW,
  PAYMENT_UPSELL_TRIGGER,
} from '../types';
import { getPlatform } from '../../utils/helpers';

const platform = getPlatform();

export const startPayment = (plan, billingCycle) => async (dispatch) => {
  const priceId = `${plan}-${billingCycle}`;
  dispatch({ type: PAYMENT_SESSION_LOADING });
  try {
    const response = await axios.post('/api/payments/pay', { priceId, platform });
    return dispatch({
      type: PAYMENT_SESSION_SUCCESS,
      data: response.data,
    });
  } catch (err) {
    return dispatch({
      type: PAYMENT_SESSION_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const setupPortal = () => async (dispatch) => {
  dispatch({ type: PAYMENT_SESSION_LOADING });
  try {
    const response = await axios.get('/api/payments/portal');
    return dispatch({
      type: PAYMENT_SESSION_SUCCESS,
      data: response.data,
    });
  } catch (err) {
    return dispatch({
      type: PAYMENT_SESSION_FAIL,
      payload: { error: err?.response?.data.message || err.message },
    });
  }
};

export const showUpselling = (from, formCount) => async (dispatch) => {
  axios.patch('/api/users/upsellTrigger', { trigger: from });
  return dispatch({
    type: PAYMENT_UPSELL_SHOW,
    payload: { from, formCount },
  });
};

export const upsellTrigger = (from) => async (dispatch) => {
  axios.patch('/api/users/upsellTrigger', { trigger: from });
  return dispatch({
    type: PAYMENT_UPSELL_TRIGGER,
  });
};

export const hideUpselling = () => async (dispatch) => {
  return dispatch({
    type: PAYMENT_UPSELL_HIDE,
  });
};
